var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
    [
      _c("div", [
        _c("div", [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _vm.$store.state.brandCreditsRemaining > 0 &&
              !_vm.loadingCredits &&
              _vm.OnBoarded == 1 &&
              _vm.geoPicklFeature
                ? _c("div", { staticClass: "create-progress" }, [
                    _c("div", { staticClass: "progress-line" }, [
                      _c("hr", {
                        staticClass: "done",
                        style: { width: (_vm.step - 1) * 33 + "%" }
                      }),
                      _c("hr", { style: { width: (4 - _vm.step) * 33 + "%" } })
                    ]),
                    _c("div", [
                      _c("div", { staticClass: "step-part" }, [
                        _c(
                          "span",
                          {
                            staticClass: "step-circle",
                            class: { active: _vm.step == 1, done: _vm.step > 1 }
                          },
                          [
                            _vm._v("\n                  1\n                  "),
                            _c("span", { staticClass: "step-label" }, [
                              _vm._v("Product")
                            ])
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "step-part" }, [
                        _c(
                          "span",
                          {
                            staticClass: "step-circle",
                            class: { active: _vm.step == 2, done: _vm.step > 2 }
                          },
                          [
                            _vm._v("\n                  2\n                  "),
                            _c("span", { staticClass: "step-label" }, [
                              _vm._v("Tasks")
                            ])
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "step-part" }, [
                        _c(
                          "span",
                          {
                            staticClass: "step-circle",
                            class: { active: _vm.step == 3 }
                          },
                          [
                            _vm._v("\n                  3\n                  "),
                            _c("span", { staticClass: "step-label" }, [
                              _vm._v("Target")
                            ])
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "step-part" }, [
                        _c(
                          "span",
                          {
                            staticClass: "step-circle",
                            class: { active: _vm.step == 4 }
                          },
                          [
                            _vm._v("\n                  4\n                  "),
                            _c("span", { staticClass: "step-label" }, [
                              _vm._v("Stores")
                            ])
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._m(0)
          ]),
          _c("button", {
            ref: "closeCreatePicklPopupButton",
            staticClass: "close",
            attrs: {
              type: "button",
              "data-dismiss": "modal",
              "aria-label": "Close"
            }
          })
        ]),
        _vm.$store.state.brandCreditsRemaining > 0 &&
        !_vm.loadingCredits &&
        _vm.OnBoarded == 1 &&
        _vm.geoPicklFeature
          ? _c("div", { staticClass: "modal-body" }, [
              _vm.step == 1 && !_vm.showProductForm
                ? _c(
                    "form",
                    {
                      attrs: { "data-vv-scope": "select-product-form" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.step1($event)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "row mt15" }, [
                        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                          _c("h2", { staticClass: "text-center sub-heading" }, [
                            _vm._v("Campaign Name")
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.pickl.campaignName,
                                expression: "pickl.campaignName"
                              }
                            ],
                            attrs: {
                              placeholder: "Enter Campaign Name",
                              type: "text"
                            },
                            domProps: { value: _vm.pickl.campaignName },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.pickl,
                                  "campaignName",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                          _c("h2", { staticClass: "text-center sub-heading" }, [
                            _vm._v("Unlock Code")
                          ]),
                          _vm.localPicklFeature
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.pickl.unlockCode,
                                    expression: "pickl.unlockCode"
                                  }
                                ],
                                attrs: {
                                  type: "text",
                                  maxlength: "6",
                                  placeholder:
                                    "Create Private Code (6 Characters Max)"
                                },
                                domProps: { value: _vm.pickl.unlockCode },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.pickl,
                                        "unlockCode",
                                        $event.target.value
                                      )
                                    },
                                    function($event) {
                                      _vm.pickl.unlockCode = $event.target.value.toUpperCase()
                                    }
                                  ]
                                }
                              })
                            : _c(
                                "h3",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm._v(
                                    "Contact us to use codes for consumer communities"
                                  )
                                ]
                              )
                        ])
                      ]),
                      _c("div", { staticClass: "row mt15" }, [
                        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                          _c("h2", { staticClass: "text-center sub-heading" }, [
                            _vm._v("Consumer Insights")
                          ]),
                          _vm.showSurveyField
                            ? _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.survey_id,
                                      expression: "pickl.survey_id"
                                    }
                                  ],
                                  attrs: { name: "survey_id" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.pickl,
                                        "survey_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        disabled: "",
                                        selected: "",
                                        value: ""
                                      }
                                    },
                                    [_vm._v("Select Insight")]
                                  ),
                                  _vm._l(_vm.surveys, function(survey) {
                                    return _c(
                                      "option",
                                      {
                                        key: survey.id,
                                        domProps: { value: survey.id }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(survey.title) +
                                            " - " +
                                            _vm._s(survey.type) +
                                            " (" +
                                            _vm._s(
                                              survey.survey_questions_count
                                            ) +
                                            " Questions)"
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _c(
                                "h3",
                                { staticStyle: { "text-align": "center" } },
                                [_vm._v(_vm._s(_vm.surveyUnavailableMessage))]
                              )
                        ]),
                        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                          _c("h2", { staticClass: "text-center sub-heading" }, [
                            _vm._v("Deal Drop")
                          ]),
                          _vm.couponFeature
                            ? _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.coupon_id,
                                      expression: "pickl.coupon_id"
                                    }
                                  ],
                                  class: "input",
                                  attrs: { name: "product_id" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.pickl,
                                        "coupon_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        disabled: "",
                                        selected: "",
                                        value: ""
                                      }
                                    },
                                    [_vm._v("Select Coupon")]
                                  ),
                                  _vm._l(_vm.brandCoupons, function(coupon) {
                                    return _c(
                                      "option",
                                      {
                                        key: coupon.id,
                                        domProps: { value: coupon.id }
                                      },
                                      [_vm._v(_vm._s(coupon.name))]
                                    )
                                  })
                                ],
                                2
                              )
                            : _c(
                                "h3",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm._v(
                                    "Contact us to activate consumer coupons & deals"
                                  )
                                ]
                              )
                        ])
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6",
                            staticStyle: { padding: "0" }
                          },
                          [
                            _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                              _c(
                                "h2",
                                {
                                  staticClass: "text-center sub-heading",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v("When? (PST)")]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "block",
                                    margin: "auto",
                                    "margin-bottom": "10px"
                                  }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.pickl.immediate_start,
                                        expression: "pickl.immediate_start"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "immediate"
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.pickl.immediate_start
                                      )
                                        ? _vm._i(
                                            _vm.pickl.immediate_start,
                                            null
                                          ) > -1
                                        : _vm.pickl.immediate_start
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.pickl.immediate_start,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.pickl,
                                                "immediate_start",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.pickl,
                                                "immediate_start",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.pickl,
                                            "immediate_start",
                                            $$c
                                          )
                                        }
                                      }
                                    }
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticStyle: { color: "black" },
                                      attrs: { for: "immediate" }
                                    },
                                    [_vm._v("Launch Now")]
                                  ),
                                  _c("br")
                                ]
                              )
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-xs-6 col-sm-6" },
                              [
                                _c("date-picker", {
                                  attrs: {
                                    disabled: _vm.pickl.immediate_start,
                                    "input-name": "start_date_time",
                                    lang: "en",
                                    type: "date",
                                    editable: false,
                                    format: "MM-DD-YYYY",
                                    "input-class": "input",
                                    width: "100%"
                                  },
                                  model: {
                                    value: _vm.date,
                                    callback: function($$v) {
                                      _vm.date = $$v
                                    },
                                    expression: "date"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-xs-6 col-sm-6" },
                              [
                                _c("date-picker", {
                                  staticClass: "timepicker",
                                  attrs: {
                                    disabled: _vm.pickl.immediate_start,
                                    "input-name": "start_date_time",
                                    lang: "en",
                                    type: "time",
                                    editable: false,
                                    format: "h a",
                                    "minute-step": 30,
                                    "time-picker-options": {
                                      start: "00:00",
                                      step: "01:00",
                                      end: "23:00"
                                    },
                                    "input-class": "input",
                                    width: "100%",
                                    placeholder: "Select Time"
                                  },
                                  model: {
                                    value: _vm.time,
                                    callback: function($$v) {
                                      _vm.time = $$v
                                    },
                                    expression: "time"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "black",
                                  "margin-left": "2%"
                                }
                              },
                              [
                                _vm._v(
                                  " PICKL tasks expire in " +
                                    _vm._s(
                                      Math.round(
                                        _vm.$store.state.settings
                                          .pickl_expiration_time / 24
                                      )
                                    ) +
                                    " days"
                                )
                              ]
                            ),
                            _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                              _c("br"),
                              _c(
                                "h2",
                                {
                                  staticClass: "text-center sub-heading",
                                  staticStyle: { "text-align": "center" }
                                },
                                [_vm._v("Auto Extend Tasks?")]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "block",
                                    margin: "auto",
                                    "margin-bottom": "10px"
                                  }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.pickl.autoExtend,
                                        expression: "pickl.autoExtend"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "autoextend"
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.pickl.autoExtend
                                      )
                                        ? _vm._i(_vm.pickl.autoExtend, null) >
                                          -1
                                        : _vm.pickl.autoExtend
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.pickl.autoExtend,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.pickl,
                                                "autoExtend",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.pickl,
                                                "autoExtend",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(_vm.pickl, "autoExtend", $$c)
                                        }
                                      }
                                    }
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticStyle: { color: "black" },
                                      attrs: { for: "autoextend" }
                                    },
                                    [_vm._v("Activate")]
                                  ),
                                  _c("br")
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "col-xs-6 col-sm-6" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.extendCounter,
                                      expression: "pickl.extendCounter"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "min:1",
                                      expression: "'min:1'"
                                    }
                                  ],
                                  class: {
                                    input: true,
                                    "is-danger": _vm.errors.has(
                                      "select-product-form.extend_counter"
                                    )
                                  },
                                  attrs: {
                                    disabled: !_vm.pickl.autoExtend,
                                    name: "extend_counter"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.pickl,
                                        "extendCounter",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { domProps: { value: 0 } }, [
                                    _vm._v("# Extentions")
                                  ]),
                                  _vm._l(_vm.maxExtendCounter, function(
                                    counter
                                  ) {
                                    return _c("option", { key: counter }, [
                                      _vm._v(_vm._s(counter))
                                    ])
                                  })
                                ],
                                2
                              )
                            ]),
                            _c("div", { staticClass: "col-xs-6 col-sm-6" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.extendDays,
                                      expression: "pickl.extendDays"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "min:1",
                                      expression: "'min:1'"
                                    }
                                  ],
                                  class: {
                                    input: true,
                                    "is-danger": _vm.errors.has(
                                      "select-product-form.extend_days"
                                    )
                                  },
                                  attrs: {
                                    disabled: !_vm.pickl.autoExtend,
                                    name: "extend_days"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.pickl,
                                        "extendDays",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: { disabled: "" },
                                      domProps: { value: 0 }
                                    },
                                    [_vm._v("# Days")]
                                  ),
                                  _vm._l(_vm.maxExtendDays, function(counter) {
                                    return _c("option", { key: counter }, [
                                      _vm._v(_vm._s(counter))
                                    ])
                                  })
                                ],
                                2
                              )
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-6",
                            staticStyle: { padding: "0" }
                          },
                          [
                            _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                              _c(
                                "h2",
                                {
                                  staticClass: "text-center sub-heading",
                                  staticStyle: {
                                    "text-align": "center",
                                    "margin-bottom": "30px"
                                  }
                                },
                                [_vm._v(" Notes For Consumer")]
                              ),
                              _c("br"),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.pickl.description,
                                    expression: "pickl.description"
                                  }
                                ],
                                staticClass: "input textarea",
                                staticStyle: { "min-height": "50px" },
                                attrs: {
                                  maxlength: "60",
                                  placeholder: "60 Characters Max",
                                  rows: "1"
                                },
                                domProps: { value: _vm.pickl.description },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.pickl,
                                      "description",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "green-border-box",
                                  staticStyle: { padding: "15px" }
                                },
                                [
                                  _vm.selfieFeatureAvailable && _vm.step == 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "col-sm-12",
                                          staticStyle: { display: "block" }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.pickl.takeSelfie,
                                                expression: "pickl.takeSelfie"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: "take-selfie"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.pickl.takeSelfie
                                              )
                                                ? _vm._i(
                                                    _vm.pickl.takeSelfie,
                                                    null
                                                  ) > -1
                                                : _vm.pickl.takeSelfie
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = _vm.pickl.takeSelfie,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.pickl,
                                                        "takeSelfie",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.pickl,
                                                        "takeSelfie",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.pickl,
                                                    "takeSelfie",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticStyle: {
                                                color: "black",
                                                "margin-top": "5px"
                                              },
                                              attrs: { for: "take-selfie" }
                                            },
                                            [_vm._v("Social Selfie?")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.multiTaskFeature && _vm.step == 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "col-sm-12",
                                          staticStyle: { display: "block" }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.pickl.multipleResponses,
                                                expression:
                                                  "pickl.multipleResponses"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: "multiple-responses"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.pickl.multipleResponses
                                              )
                                                ? _vm._i(
                                                    _vm.pickl.multipleResponses,
                                                    null
                                                  ) > -1
                                                : _vm.pickl.multipleResponses
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.pickl.multipleResponses,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.pickl,
                                                        "multipleResponses",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.pickl,
                                                        "multipleResponses",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.pickl,
                                                    "multipleResponses",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticStyle: {
                                                color: "black",
                                                "margin-top": "5px"
                                              },
                                              attrs: {
                                                for: "multiple-responses"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "1 Location Multiple Responses?"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.reimbursementFeature && _vm.step == 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "col-sm-12",
                                          staticStyle: { display: "block" }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.pickl.hasReimbursement,
                                                expression:
                                                  "pickl.hasReimbursement"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: "reimbursement"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.pickl.hasReimbursement
                                              )
                                                ? _vm._i(
                                                    _vm.pickl.hasReimbursement,
                                                    null
                                                  ) > -1
                                                : _vm.pickl.hasReimbursement
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.pickl.hasReimbursement,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.pickl,
                                                        "hasReimbursement",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.pickl,
                                                        "hasReimbursement",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.pickl,
                                                    "hasReimbursement",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticStyle: {
                                                color: "black",
                                                "margin-top": "5px"
                                              },
                                              attrs: { for: "reimbursement" }
                                            },
                                            [
                                              _vm._v(
                                                "Consumer Reimbursement/BuyMe?"
                                              )
                                            ]
                                          ),
                                          _vm.pickl.hasReimbursement
                                            ? _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.pickl
                                                          .reimbursementCredits,
                                                      expression:
                                                        "pickl.reimbursementCredits"
                                                    }
                                                  ],
                                                  staticClass: "btn-select-box",
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.$set(
                                                        _vm.pickl,
                                                        "reimbursementCredits",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    { attrs: { value: "0" } },
                                                    [
                                                      _vm._v(
                                                        "Select Reimbursement Credits"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._l(
                                                    _vm.counterReimbursementDropDownList,
                                                    function(n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n,
                                                          domProps: { value: n }
                                                        },
                                                        [_vm._v(_vm._s(n))]
                                                      )
                                                    }
                                                  ),
                                                  _c(
                                                    "option",
                                                    { domProps: { value: 10 } },
                                                    [_vm._v("10")]
                                                  ),
                                                  _c(
                                                    "option",
                                                    { domProps: { value: 12 } },
                                                    [_vm._v("12")]
                                                  ),
                                                  _c(
                                                    "option",
                                                    { domProps: { value: 14 } },
                                                    [_vm._v("14")]
                                                  ),
                                                  _c(
                                                    "option",
                                                    { domProps: { value: 15 } },
                                                    [_vm._v("15")]
                                                  ),
                                                  _c(
                                                    "option",
                                                    { domProps: { value: 20 } },
                                                    [_vm._v("20")]
                                                  ),
                                                  _c(
                                                    "option",
                                                    { domProps: { value: 22 } },
                                                    [_vm._v("22")]
                                                  ),
                                                  _c(
                                                    "option",
                                                    { domProps: { value: 25 } },
                                                    [_vm._v("25")]
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _c("input", {
                                staticClass: "btn-lg-green w50 pull-right",
                                staticStyle: {
                                  width: "100%",
                                  display: "block",
                                  "margin-top": "30px"
                                },
                                attrs: { type: "submit", value: "NEXT" }
                              })
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.step == 1 && _vm.showProductForm
                ? _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.addProduct($event)
                        }
                      }
                    },
                    [
                      _c("h2", { staticClass: "text-center sub-heading" }, [
                        _vm._v("What Product?")
                      ]),
                      _c("ProductForm", {
                        ref: "productForm",
                        attrs: { brandId: _vm.brandId },
                        on: {
                          added: _vm.refreshProductList,
                          failed: function($event) {
                            _vm.busy = false
                          }
                        }
                      }),
                      _c("div", { staticClass: "product-buttons" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn-positive",
                            attrs: { type: "<selectbutton" },
                            on: {
                              click: function($event) {
                                _vm.showProductForm = false
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: "/img/Create Pickl/back.png" }
                            }),
                            _vm._v(" BACK\n          ")
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn-lg-green w50 fRight m0",
                            attrs: { type: "submit", disabled: _vm.busy }
                          },
                          [
                            _vm._v("ADD\n            "),
                            _c("span", { staticClass: "hidden-xs" }, [
                              _vm._v("PRODUCT")
                            ])
                          ]
                        ),
                        _c("div", { staticClass: "clearfix" })
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.step == 2
                ? _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.step2($event)
                        }
                      }
                    },
                    [
                      _c("h2", { staticClass: "sub-heading text-center" }, [
                        _vm._v("Tasks")
                      ]),
                      _c("div", { staticClass: "subtitle" }, [
                        _vm._v(
                          "Select max " +
                            _vm._s(
                              _vm.$store.state.settings.max_tasks_per_product
                            ) +
                            " tasks per product"
                        )
                      ]),
                      _c("div", { staticClass: "in-padd" }, [
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs",
                            attrs: { role: "tablist" }
                          },
                          [
                            _vm._l(_vm.pickl.products, function(
                              picklProduct,
                              index
                            ) {
                              return _c(
                                "li",
                                {
                                  key: index,
                                  class: index == 0 ? "active" : "",
                                  attrs: { role: "presentation" }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#product-" + index,
                                        "aria-controls": "product-" + index,
                                        role: "tab",
                                        "data-toggle": "tab",
                                        id: "product-link-" + index
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Product " +
                                          _vm._s(index + 1) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            _vm.pickl.products.length <
                            _vm.$store.state.settings.pickl_max_products
                              ? _c("li", { attrs: { role: "presentation" } }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#add-product" },
                                      on: {
                                        click: function($event) {
                                          return _vm.addProductToPickl()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                + Product\n              "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "tab-content" },
                          _vm._l(_vm.pickl.products, function(
                            picklProduct,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "tab-pane fade in ",
                                class: index == 0 ? "active" : "",
                                attrs: {
                                  role: "tabpanel",
                                  id: "product-" + index
                                }
                              },
                              [
                                _c("br"),
                                _c(
                                  "div",
                                  {
                                    staticClass: "row",
                                    staticStyle: { "margin-right": "1%" }
                                  },
                                  [
                                    index > 0
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "pull-right",
                                            staticStyle: { color: "red" },
                                            attrs: { href: "javascript:;" },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeProductFromPickl(
                                                  index
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Remove Product")]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _c(
                                  "h4",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      color: "#782b54"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Select Product " +
                                        _vm._s(index + 1) +
                                        " Tasks"
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "col-sm-6" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: picklProduct.product_id,
                                          expression: "picklProduct.product_id"
                                        }
                                      ],
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              picklProduct,
                                              "product_id",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          function($event) {
                                            return _vm.setProductImage(
                                              picklProduct.product_id,
                                              index
                                            )
                                          }
                                        ]
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Select Product")
                                      ]),
                                      _vm._l(_vm.products, function(product) {
                                        return _c(
                                          "option",
                                          {
                                            key: product.id,
                                            domProps: { value: product.id }
                                          },
                                          [_vm._v(_vm._s(product.name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _c("div", { staticClass: "col-sm-6" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: picklProduct.description,
                                        expression: "picklProduct.description"
                                      }
                                    ],
                                    staticClass: "input",
                                    attrs: {
                                      placeholder:
                                        "Description Max 40 Characters"
                                    },
                                    domProps: {
                                      value: picklProduct.description
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          picklProduct,
                                          "description",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]),
                                _c(
                                  "VuePerfectScrollbar",
                                  { staticClass: "attr-imgs" },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass: "nav nav-tabs",
                                        attrs: { role: "tablist" }
                                      },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass: "active",
                                            attrs: { role: "presentation" }
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "#dining-id-" + index,
                                                  "aria-controls": "dining",
                                                  role: "tab",
                                                  "data-toggle": "tab"
                                                }
                                              },
                                              [_vm._v("Dining")]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "li",
                                          { attrs: { role: "presentation" } },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    "#entertainment-id-" +
                                                    index,
                                                  "aria-controls":
                                                    "entertainment",
                                                  role: "tab",
                                                  "data-toggle": "tab"
                                                }
                                              },
                                              [_vm._v("Entertainment")]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "li",
                                          { attrs: { role: "presentation" } },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "#events-id-" + index,
                                                  "aria-controls": "events",
                                                  role: "tab",
                                                  "data-toggle": "tab"
                                                }
                                              },
                                              [_vm._v("Events")]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "li",
                                          { attrs: { role: "presentation" } },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    "#hospitality-id-" + index,
                                                  "aria-controls":
                                                    "hospitality",
                                                  role: "tab",
                                                  "data-toggle": "tab"
                                                }
                                              },
                                              [_vm._v("Hospitality")]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "li",
                                          { attrs: { role: "presentation" } },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "#retail-id-" + index,
                                                  "aria-controls": "retail",
                                                  role: "tab",
                                                  "data-toggle": "tab"
                                                }
                                              },
                                              [_vm._v("Retail")]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "tab-content" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tab-pane fade in active",
                                          attrs: {
                                            role: "tabpanel",
                                            id: "dining-id-" + index
                                          }
                                        },
                                        _vm._l(_vm.diningTasks, function(task) {
                                          return _c(
                                            "div",
                                            {
                                              key: task.id,
                                              staticClass:
                                                "col-xs-3 col-md-2 photo"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.pickl.products[index]
                                                        .task_ids,
                                                    expression:
                                                      "pickl.products[index].task_ids"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id:
                                                    "attr-image-" +
                                                    index +
                                                    "-" +
                                                    task.id
                                                },
                                                domProps: {
                                                  value: task.id,
                                                  checked: Array.isArray(
                                                    _vm.pickl.products[index]
                                                      .task_ids
                                                  )
                                                    ? _vm._i(
                                                        _vm.pickl.products[
                                                          index
                                                        ].task_ids,
                                                        task.id
                                                      ) > -1
                                                    : _vm.pickl.products[index]
                                                        .task_ids
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a =
                                                        _vm.pickl.products[
                                                          index
                                                        ].task_ids,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = task.id,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.pickl.products[
                                                              index
                                                            ],
                                                            "task_ids",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.pickl.products[
                                                              index
                                                            ],
                                                            "task_ids",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.pickl.products[
                                                          index
                                                        ],
                                                        "task_ids",
                                                        $$c
                                                      )
                                                    }
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "img-contain",
                                                  attrs: {
                                                    for:
                                                      "attr-image-" +
                                                      index +
                                                      "-" +
                                                      task.id
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    directives: [
                                                      {
                                                        name: "square-img",
                                                        rawName: "v-square-img",
                                                        value: { ratio: 1.5 },
                                                        expression:
                                                          "{ ratio: 1.5 }"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "vertical-center-transform",
                                                    attrs: {
                                                      src:
                                                        task.image +
                                                        _vm.lowSrcQuery
                                                    }
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "img-overlay"
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass: "img-tick",
                                                        attrs: {
                                                          src:
                                                            "/img/Create Pickl/selectpickl_icon.png"
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "vertical-center-transform task-name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(task.name)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "tab-pane fade in",
                                          attrs: {
                                            role: "tabpanel",
                                            id: "entertainment-id-" + index
                                          }
                                        },
                                        _vm._l(_vm.entertainmentTasks, function(
                                          task
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: task.id,
                                              staticClass:
                                                "col-xs-3 col-md-2 photo"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.pickl.products[index]
                                                        .task_ids,
                                                    expression:
                                                      "pickl.products[index].task_ids"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id:
                                                    "attr-image-" +
                                                    index +
                                                    "-" +
                                                    task.id
                                                },
                                                domProps: {
                                                  value: task.id,
                                                  checked: Array.isArray(
                                                    _vm.pickl.products[index]
                                                      .task_ids
                                                  )
                                                    ? _vm._i(
                                                        _vm.pickl.products[
                                                          index
                                                        ].task_ids,
                                                        task.id
                                                      ) > -1
                                                    : _vm.pickl.products[index]
                                                        .task_ids
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a =
                                                        _vm.pickl.products[
                                                          index
                                                        ].task_ids,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = task.id,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.pickl.products[
                                                              index
                                                            ],
                                                            "task_ids",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.pickl.products[
                                                              index
                                                            ],
                                                            "task_ids",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.pickl.products[
                                                          index
                                                        ],
                                                        "task_ids",
                                                        $$c
                                                      )
                                                    }
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "img-contain",
                                                  attrs: {
                                                    for:
                                                      "attr-image-" +
                                                      index +
                                                      "-" +
                                                      task.id
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    directives: [
                                                      {
                                                        name: "square-img",
                                                        rawName: "v-square-img",
                                                        value: { ratio: 1.5 },
                                                        expression:
                                                          "{ ratio: 1.5 }"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "vertical-center-transform",
                                                    attrs: {
                                                      src:
                                                        task.image +
                                                        _vm.lowSrcQuery
                                                    }
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "img-overlay"
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass: "img-tick",
                                                        attrs: {
                                                          src:
                                                            "/img/Create Pickl/selectpickl_icon.png"
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "vertical-center-transform task-name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(task.name)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "tab-pane fade in",
                                          attrs: {
                                            role: "tabpanel",
                                            id: "events-id-" + index
                                          }
                                        },
                                        _vm._l(_vm.eventsTasks, function(task) {
                                          return _c(
                                            "div",
                                            {
                                              key: task.id,
                                              staticClass:
                                                "col-xs-3 col-md-2 photo"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.pickl.products[index]
                                                        .task_ids,
                                                    expression:
                                                      "pickl.products[index].task_ids"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id:
                                                    "attr-image-" +
                                                    index +
                                                    "-" +
                                                    task.id
                                                },
                                                domProps: {
                                                  value: task.id,
                                                  checked: Array.isArray(
                                                    _vm.pickl.products[index]
                                                      .task_ids
                                                  )
                                                    ? _vm._i(
                                                        _vm.pickl.products[
                                                          index
                                                        ].task_ids,
                                                        task.id
                                                      ) > -1
                                                    : _vm.pickl.products[index]
                                                        .task_ids
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a =
                                                        _vm.pickl.products[
                                                          index
                                                        ].task_ids,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = task.id,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.pickl.products[
                                                              index
                                                            ],
                                                            "task_ids",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.pickl.products[
                                                              index
                                                            ],
                                                            "task_ids",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.pickl.products[
                                                          index
                                                        ],
                                                        "task_ids",
                                                        $$c
                                                      )
                                                    }
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "img-contain",
                                                  attrs: {
                                                    for:
                                                      "attr-image-" +
                                                      index +
                                                      "-" +
                                                      task.id
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    directives: [
                                                      {
                                                        name: "square-img",
                                                        rawName: "v-square-img",
                                                        value: { ratio: 1.5 },
                                                        expression:
                                                          "{ ratio: 1.5 }"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "vertical-center-transform",
                                                    attrs: {
                                                      src:
                                                        task.image +
                                                        _vm.lowSrcQuery
                                                    }
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "img-overlay"
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass: "img-tick",
                                                        attrs: {
                                                          src:
                                                            "/img/Create Pickl/selectpickl_icon.png"
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "vertical-center-transform task-name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(task.name)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "tab-pane fade in",
                                          attrs: {
                                            role: "tabpanel",
                                            id: "hospitality-id-" + index
                                          }
                                        },
                                        _vm._l(_vm.hospitalityTasks, function(
                                          task
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: task.id,
                                              staticClass:
                                                "col-xs-3 col-md-2 photo"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.pickl.products[index]
                                                        .task_ids,
                                                    expression:
                                                      "pickl.products[index].task_ids"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id:
                                                    "attr-image-" +
                                                    index +
                                                    "-" +
                                                    task.id
                                                },
                                                domProps: {
                                                  value: task.id,
                                                  checked: Array.isArray(
                                                    _vm.pickl.products[index]
                                                      .task_ids
                                                  )
                                                    ? _vm._i(
                                                        _vm.pickl.products[
                                                          index
                                                        ].task_ids,
                                                        task.id
                                                      ) > -1
                                                    : _vm.pickl.products[index]
                                                        .task_ids
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a =
                                                        _vm.pickl.products[
                                                          index
                                                        ].task_ids,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = task.id,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.pickl.products[
                                                              index
                                                            ],
                                                            "task_ids",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.pickl.products[
                                                              index
                                                            ],
                                                            "task_ids",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.pickl.products[
                                                          index
                                                        ],
                                                        "task_ids",
                                                        $$c
                                                      )
                                                    }
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "img-contain",
                                                  attrs: {
                                                    for:
                                                      "attr-image-" +
                                                      index +
                                                      "-" +
                                                      task.id
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    directives: [
                                                      {
                                                        name: "square-img",
                                                        rawName: "v-square-img",
                                                        value: { ratio: 1.5 },
                                                        expression:
                                                          "{ ratio: 1.5 }"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "vertical-center-transform",
                                                    attrs: {
                                                      src:
                                                        task.image +
                                                        _vm.lowSrcQuery
                                                    }
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "img-overlay"
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass: "img-tick",
                                                        attrs: {
                                                          src:
                                                            "/img/Create Pickl/selectpickl_icon.png"
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "vertical-center-transform task-name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(task.name)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "tab-pane fade in",
                                          attrs: {
                                            role: "tabpanel",
                                            id: "retail-id-" + index
                                          }
                                        },
                                        _vm._l(_vm.retailTasks, function(task) {
                                          return _c(
                                            "div",
                                            {
                                              key: task.id,
                                              staticClass:
                                                "col-xs-3 col-md-2 photo"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.pickl.products[index]
                                                        .task_ids,
                                                    expression:
                                                      "pickl.products[index].task_ids"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id:
                                                    "attr-image-" +
                                                    index +
                                                    "-" +
                                                    task.id
                                                },
                                                domProps: {
                                                  value: task.id,
                                                  checked: Array.isArray(
                                                    _vm.pickl.products[index]
                                                      .task_ids
                                                  )
                                                    ? _vm._i(
                                                        _vm.pickl.products[
                                                          index
                                                        ].task_ids,
                                                        task.id
                                                      ) > -1
                                                    : _vm.pickl.products[index]
                                                        .task_ids
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a =
                                                        _vm.pickl.products[
                                                          index
                                                        ].task_ids,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = task.id,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.pickl.products[
                                                              index
                                                            ],
                                                            "task_ids",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.pickl.products[
                                                              index
                                                            ],
                                                            "task_ids",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.pickl.products[
                                                          index
                                                        ],
                                                        "task_ids",
                                                        $$c
                                                      )
                                                    }
                                                  }
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "img-contain",
                                                  attrs: {
                                                    for:
                                                      "attr-image-" +
                                                      index +
                                                      "-" +
                                                      task.id
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    directives: [
                                                      {
                                                        name: "square-img",
                                                        rawName: "v-square-img",
                                                        value: { ratio: 1.5 },
                                                        expression:
                                                          "{ ratio: 1.5 }"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "vertical-center-transform",
                                                    attrs: {
                                                      src:
                                                        task.image +
                                                        _vm.lowSrcQuery
                                                    }
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "img-overlay"
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass: "img-tick",
                                                        attrs: {
                                                          src:
                                                            "/img/Create Pickl/selectpickl_icon.png"
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "vertical-center-transform task-name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(task.name)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]),
                                    _c("div", { staticClass: "clearfix" })
                                  ]
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn-lg-grey",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.step = 1
                                }
                              }
                            },
                            [_vm._v("PREVIOUS")]
                          )
                        ]),
                        _vm._m(1)
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.step == 3
                ? _c("div", [
                    _vm.demographicsFilterFeature
                      ? _c(
                          "div",
                          {
                            staticClass: "row",
                            staticStyle: {
                              "padding-right": "15%",
                              "padding-left": "15%"
                            }
                          },
                          [
                            _c(
                              "h2",
                              { staticClass: "sub-heading text-center" },
                              [_vm._v("Set Target Audience (Optional Step)")]
                            ),
                            _vm._l(_vm.pickl.filters, function(filter, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "col-sm-12",
                                  staticStyle: {
                                    padding: "1%",
                                    "background-color": "gainsboro"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "col-sm-5" }, [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: filter.type,
                                            expression: "filter.type"
                                          }
                                        ],
                                        staticClass: "btn-select-box",
                                        staticStyle: { "margin-top": "8px" },
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                filter,
                                                "type",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                            function($event) {
                                              return _vm.makeSelectedFilterOptionsEmpty(
                                                index
                                              )
                                            }
                                          ]
                                        }
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }, [
                                          _vm._v("Select Audeience Filter")
                                        ]),
                                        _vm._l(_vm.filters, function(filter) {
                                          return _c(
                                            "option",
                                            {
                                              key: filter.key,
                                              domProps: { value: filter.key }
                                            },
                                            [_vm._v(_vm._s(filter.label))]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-6" },
                                    [
                                      _c("multiselect", {
                                        attrs: {
                                          options:
                                            _vm.filterOptions[filter.type],
                                          multiple: true,
                                          "close-on-select": false,
                                          "clear-on-select": false,
                                          "preserve-search": true,
                                          placeholder: "Select values",
                                          taggable: true
                                        },
                                        on: { tag: _vm.addTag },
                                        model: {
                                          value: filter.values,
                                          callback: function($$v) {
                                            _vm.$set(filter, "values", $$v)
                                          },
                                          expression: "filter.values"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-sm-1",
                                      staticStyle: {
                                        "margin-top": "6px",
                                        "margin-bottom": "5px"
                                      }
                                    },
                                    [
                                      index != 0
                                        ? _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                color: "white",
                                                background: "rgb(120, 43, 86)",
                                                "border-radius": "63px",
                                                "padding-left": "5px",
                                                "padding-right": "5px",
                                                "padding-bottom": "0px",
                                                "padding-top": "2px"
                                              },
                                              attrs: { href: "javascript:;" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeFilter(index)
                                                }
                                              }
                                            },
                                            [_vm._v(" X ")]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            }),
                            _c(
                              "div",
                              {
                                staticStyle: { display: "block", width: "100%" }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-positive pull-right",
                                    staticStyle: {
                                      "margin-top": "5px",
                                      display: "block"
                                    },
                                    attrs: { href: "javascript:;" },
                                    on: { click: _vm.addMoreFilter }
                                  },
                                  [_vm._v("Add More")]
                                )
                              ]
                            )
                          ],
                          2
                        )
                      : _c(
                          "h2",
                          {
                            staticStyle: {
                              "text-align": "center",
                              padding: "5%"
                            }
                          },
                          [
                            _vm._v(
                              "Contact us to activate demographics filter for your campaign"
                            )
                          ]
                        ),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn-lg-grey",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.step = 2
                              }
                            }
                          },
                          [_vm._v("PREVIOUS")]
                        )
                      ]),
                      _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn-lg-green",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.step = 4
                              }
                            }
                          },
                          [_vm._v("NEXT")]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.step == 4
                ? _c("div", [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-3" }),
                      _c("div", { staticClass: "col-sm-6" }, [
                        _c("h2", { staticClass: "sub-heading text-center" }, [
                          _vm._v("Select Type Of Campaign You Want To Launch")
                        ]),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.pickl.launchType,
                                expression: "pickl.launchType"
                              }
                            ],
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.pickl,
                                  "launchType",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Select Campaign Type")
                            ]),
                            _c(
                              "option",
                              {
                                attrs: { value: "retailer-specific-location" }
                              },
                              [_vm._v("Specific Physical Location")]
                            ),
                            _c(
                              "option",
                              { attrs: { value: "retailer-any-location" } },
                              [_vm._v("Any Physical Location")]
                            ),
                            _c(
                              "option",
                              { attrs: { value: "global-any-location" } },
                              [_vm._v("Create Physical Location")]
                            )
                          ]
                        ),
                        _c("hr")
                      ]),
                      _vm._m(2)
                    ]),
                    _vm.pickl.launchType == "retailer-specific-location"
                      ? _c("div", [
                          _c("div", { staticClass: "filter-row" }, [
                            _c("div", { staticClass: "filter-control" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.countryId,
                                      expression: "pickl.countryId"
                                    }
                                  ],
                                  staticClass: "btn-select-box",
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.pickl,
                                          "countryId",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.getStates
                                    ]
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("Select Country")
                                  ]),
                                  _vm._l(_vm.countries, function(country) {
                                    return _c(
                                      "option",
                                      {
                                        key: country.id,
                                        domProps: { value: country.id }
                                      },
                                      [_vm._v(_vm._s(country.name))]
                                    )
                                  })
                                ],
                                2
                              )
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.stateId,
                                      expression: "stateId"
                                    }
                                  ],
                                  staticClass: "btn-select-box",
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.stateId = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                      _vm.getStoresList
                                    ]
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "", selected: "" } },
                                    [_vm._v("Select State")]
                                  ),
                                  _vm._l(_vm.states, function(state) {
                                    return _c(
                                      "option",
                                      {
                                        key: state.id,
                                        domProps: { value: state.id }
                                      },
                                      [_vm._v(_vm._s(state.name))]
                                    )
                                  })
                                ],
                                2
                              )
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.storeId,
                                      expression: "storeId"
                                    }
                                  ],
                                  staticClass: "btn-select-box",
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.storeId = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                      function($event) {
                                        return _vm.updateStoreHandler(true)
                                      }
                                    ]
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "", selected: "" } },
                                    [_vm._v("Select Retailer")]
                                  ),
                                  _vm._l(_vm.retailers, function(retailer) {
                                    return _c(
                                      "option",
                                      {
                                        key: retailer.id,
                                        domProps: { value: retailer.id }
                                      },
                                      [_vm._v(_vm._s(retailer.name))]
                                    )
                                  })
                                ],
                                2
                              )
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.storeCity,
                                    expression: "storeCity"
                                  }
                                ],
                                staticClass:
                                  "btn-select font-14px disabled-gray",
                                attrs: {
                                  type: "text",
                                  disabled: !_vm.checkIfStateRetailerSelected,
                                  placeholder: "City"
                                },
                                domProps: { value: _vm.storeCity },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.storeCity = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.storeZipCode,
                                    expression: "storeZipCode"
                                  }
                                ],
                                staticClass:
                                  "btn-select font-14px disabled-gray",
                                attrs: {
                                  type: "text",
                                  disabled: !_vm.checkIfStateRetailerSelected,
                                  placeholder: "Zipcode"
                                },
                                domProps: { value: _vm.storeZipCode },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.storeZipCode = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.pickl.credits,
                                    expression: "pickl.credits"
                                  }
                                ],
                                staticClass: "btn-select font-14px",
                                attrs: {
                                  type: "text",
                                  placeholder: "$ Payout"
                                },
                                domProps: { value: _vm.pickl.credits },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.pickl,
                                      "credits",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm.pickl.multipleResponses
                              ? _c("div", { staticClass: "filter-control" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.pickl.responseCounter,
                                          expression: "pickl.responseCounter"
                                        }
                                      ],
                                      staticClass: "btn-select-box",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            _vm.pickl,
                                            "responseCounter",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Responses per location")
                                      ]),
                                      _vm._l(_vm.counterDropDownList, function(
                                        number
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: number,
                                            domProps: { value: number }
                                          },
                                          [_vm._v(_vm._s(number))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm.pickl.launchType == "retailer-specific-location"
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-sm-4" }),
                                _c("div", { staticClass: "col-sm-4" }, [
                                  _c(
                                    "h3",
                                    { staticStyle: { "text-align": "center" } },
                                    [_vm._v("Or")]
                                  ),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedLocationCatalogue,
                                          expression:
                                            "selectedLocationCatalogue"
                                        }
                                      ],
                                      staticClass: "btn-select-box",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.selectedLocationCatalogue = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          _vm.getCatalogueStoreLocations
                                        ]
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "0" } }, [
                                        _vm._v("Select Store Cluster")
                                      ]),
                                      _vm._l(_vm.locationCatalogues, function(
                                        catalouge
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: catalouge.id,
                                            domProps: { value: catalouge.id }
                                          },
                                          [_vm._v(_vm._s(catalouge.name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]),
                                _c("div", { staticClass: "col-sm-4" })
                              ])
                            : _vm._e(),
                          _vm.duplicatePicklErrorMessage != ""
                            ? _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.duplicatePicklErrorMessage
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm.duplicatePicklLocationIds.length > 0
                            ? _c(
                                "a",
                                {
                                  staticStyle: {
                                    display: "block",
                                    "text-align": "right",
                                    "margin-bottom": "10px",
                                    color: "#782B54",
                                    cursor: "pointer",
                                    "text-decoration": "none"
                                  },
                                  on: { click: _vm.removeDuplicateLocations }
                                },
                                [_vm._v("Remove Duplicate Locations")]
                              )
                            : _vm._e(),
                          _vm.updatedStores.length > 0 ||
                          _vm.selectedRetails.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "green-border-box mb10 checklist"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-6" },
                                    [
                                      _vm.pickl.multipleResponses == 0
                                        ? _c(
                                            "div",
                                            { staticClass: "checklist-head" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.selectAll,
                                                    expression: "selectAll"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id: "all-stores"
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.selectAll
                                                  )
                                                    ? _vm._i(
                                                        _vm.selectAll,
                                                        null
                                                      ) > -1
                                                    : _vm.selectAll
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$a = _vm.selectAll,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.selectAll = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.selectAll = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.selectAll = $$c
                                                      }
                                                    },
                                                    _vm.onSelectAll
                                                  ]
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  attrs: { for: "all-stores" }
                                                },
                                                [_vm._v("Select All Retailers")]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "VuePerfectScrollbar",
                                        { staticClass: "checklist-contain" },
                                        [
                                          _c(
                                            "ul",
                                            { staticClass: "checklist-body" },
                                            _vm._l(_vm.updatedStores, function(
                                              store
                                            ) {
                                              return _c(
                                                "li",
                                                {
                                                  key: store.id,
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setSelected(
                                                        store,
                                                        !store.selected
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "checklist-item"
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticStyle: {
                                                          float: "left",
                                                          "margin-right": "3px",
                                                          "margin-top": "4px"
                                                        },
                                                        attrs: {
                                                          src: store.store.image
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            title:
                                                              store.store.name
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              store.store.name
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "address",
                                                          attrs: {
                                                            title: store.address
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              store.address
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm.inSelectedStoresList(
                                                        store
                                                      )
                                                        ? _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/img/Create Pickl/storenameSelect_icon.png"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-6" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "checklist-head" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticStyle: { display: "block" },
                                              attrs: { for: "all-stores" }
                                            },
                                            [
                                              _vm._v("Ready To Blast "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "pull-right",
                                                  staticStyle: {
                                                    color: "#782b54",
                                                    "font-weight": "bold"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Remaining Credits: " +
                                                      _vm._s(_vm.creditsLeft) +
                                                      "/" +
                                                      _vm._s(
                                                        _vm.$store.state
                                                          .brandCreditsRemaining
                                                      )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "VuePerfectScrollbar",
                                        { staticClass: "checklist-contain" },
                                        [
                                          _vm.selectedRetails.length > 0
                                            ? _c(
                                                "ul",
                                                {
                                                  staticClass: "checklist-body"
                                                },
                                                _vm._l(
                                                  _vm.selectedRetails,
                                                  function(ss, index) {
                                                    return _c(
                                                      "li",
                                                      { key: ss.id },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "checklist-item"
                                                          },
                                                          [
                                                            _c("img", {
                                                              staticStyle: {
                                                                float: "left",
                                                                "margin-right":
                                                                  "3px",
                                                                "margin-top":
                                                                  "4px"
                                                              },
                                                              attrs: {
                                                                src: ss.image
                                                              }
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                attrs: {
                                                                  title: ss.name
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    ss.name
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "address",
                                                                attrs: {
                                                                  title:
                                                                    ss.address
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    ss.address
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c("img", {
                                                              staticClass:
                                                                "remove-icon",
                                                              staticStyle: {
                                                                width: "24px",
                                                                height: "24px"
                                                              },
                                                              attrs: {
                                                                src:
                                                                  "/img/Create Pickl/cancel_purple.png"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeRetailer(
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _c(
                                                "h2",
                                                {
                                                  staticStyle: {
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Not Retailer Selected"
                                                  )
                                                ]
                                              )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm.pickl.launchType == "retailer-any-location"
                      ? _c("div", [
                          _c("div", { staticClass: "filter-row" }, [
                            _c("div", { staticClass: "filter-control" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.countryId,
                                      expression: "pickl.countryId"
                                    }
                                  ],
                                  staticClass: "btn-select-box",
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.pickl,
                                          "countryId",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.getStates
                                    ]
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("Select Country")
                                  ]),
                                  _vm._l(_vm.countries, function(country) {
                                    return _c(
                                      "option",
                                      {
                                        key: country.id,
                                        domProps: { value: country.id }
                                      },
                                      [_vm._v(_vm._s(country.name))]
                                    )
                                  })
                                ],
                                2
                              )
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.launchArea,
                                      expression: "pickl.launchArea"
                                    }
                                  ],
                                  staticClass: "btn-select-box",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.pickl,
                                        "launchArea",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("Select Launch Area")
                                  ]),
                                  _c("option", { attrs: { value: "states" } }, [
                                    _vm._v("States")
                                  ]),
                                  _c("option", { attrs: { value: "cities" } }, [
                                    _vm._v("Cities")
                                  ])
                                ]
                              )
                            ]),
                            _vm.pickl.launchArea == "cities"
                              ? _c("div", { staticClass: "filter-control" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.stateId,
                                          expression: "stateId"
                                        }
                                      ],
                                      staticClass: "btn-select-box",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.stateId = $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          _vm.getStateCities
                                        ]
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v("Select State")
                                      ]),
                                      _vm._l(_vm.states, function(state) {
                                        return _c(
                                          "option",
                                          {
                                            key: state.id,
                                            domProps: { value: state.id }
                                          },
                                          [_vm._v(_vm._s(state.name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ])
                              : _vm._e(),
                            _c("div", { staticClass: "filter-control" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.selectedRetailerId,
                                      expression: "pickl.selectedRetailerId"
                                    }
                                  ],
                                  staticClass: "btn-select-box",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.pickl,
                                        "selectedRetailerId",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("Select Retailer")
                                  ]),
                                  _vm._l(_vm.allRetailers, function(retailer) {
                                    return _c(
                                      "option",
                                      {
                                        key: retailer.id,
                                        domProps: { value: retailer.id }
                                      },
                                      [_vm._v(_vm._s(retailer.name))]
                                    )
                                  })
                                ],
                                2
                              )
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.maxTasksPerUser,
                                      expression: "pickl.maxTasksPerUser"
                                    }
                                  ],
                                  staticClass: "btn-select-box",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.pickl,
                                        "maxTasksPerUser",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("Single User Limit")
                                  ]),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("1")
                                  ]),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v("2")
                                  ]),
                                  _c("option", { attrs: { value: "3" } }, [
                                    _vm._v("3")
                                  ]),
                                  _c("option", { attrs: { value: "4" } }, [
                                    _vm._v("4")
                                  ]),
                                  _c("option", { attrs: { value: "5" } }, [
                                    _vm._v("5")
                                  ])
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.responseCounter,
                                      expression: "pickl.responseCounter"
                                    }
                                  ],
                                  staticClass: "btn-select-box",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.pickl,
                                        "responseCounter",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("Total Activity count")
                                  ]),
                                  _vm._l(_vm.counterDropDownList, function(
                                    number
                                  ) {
                                    return _c(
                                      "option",
                                      {
                                        key: number,
                                        domProps: { value: number }
                                      },
                                      [_vm._v(_vm._s(number))]
                                    )
                                  })
                                ],
                                2
                              )
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.pickl.credits,
                                    expression: "pickl.credits"
                                  }
                                ],
                                staticClass: "btn-select font-14px",
                                attrs: {
                                  type: "text",
                                  placeholder: "$5 Incentives"
                                },
                                domProps: { value: _vm.pickl.credits },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.pickl,
                                      "credits",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm.pickl.launchArea == "cities"
                            ? _c(
                                "div",
                                {
                                  staticClass: "green-border-box mb10 checklist"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-6" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "checklist-head" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.citiesSelectAll,
                                                expression: "citiesSelectAll"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: "all-stores"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.citiesSelectAll
                                              )
                                                ? _vm._i(
                                                    _vm.citiesSelectAll,
                                                    null
                                                  ) > -1
                                                : _vm.citiesSelectAll
                                            },
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$a = _vm.citiesSelectAll,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.citiesSelectAll = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.citiesSelectAll = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.citiesSelectAll = $$c
                                                  }
                                                },
                                                _vm.onSelectAllCities
                                              ]
                                            }
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "all-stores" } },
                                            [_vm._v("Select Cities")]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "VuePerfectScrollbar",
                                        { staticClass: "checklist-contain" },
                                        [
                                          _c(
                                            "ul",
                                            { staticClass: "checklist-body" },
                                            _vm._l(_vm.cities, function(city) {
                                              return _c(
                                                "li",
                                                {
                                                  key: city.id,
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setCitySelected(
                                                        city,
                                                        !city.selected
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "checklist-item"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            title: city.name
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(city.name)
                                                          )
                                                        ]
                                                      ),
                                                      _vm.inSelectedCitiesList(
                                                        city
                                                      )
                                                        ? _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/img/Create Pickl/storenameSelect_icon.png"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-6" },
                                    [
                                      _vm._m(3),
                                      _c(
                                        "VuePerfectScrollbar",
                                        { staticClass: "checklist-contain" },
                                        [
                                          _vm.selectedCities.length > 0
                                            ? _c(
                                                "ul",
                                                {
                                                  staticClass: "checklist-body"
                                                },
                                                _vm._l(
                                                  _vm.selectedCities,
                                                  function(sc, index) {
                                                    return _c(
                                                      "li",
                                                      { key: sc.id },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "checklist-item"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                attrs: {
                                                                  title: sc.name
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    sc.name
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c("img", {
                                                              staticClass:
                                                                "remove-icon",
                                                              staticStyle: {
                                                                width: "24px",
                                                                height: "24px"
                                                              },
                                                              attrs: {
                                                                src:
                                                                  "/img/Create Pickl/cancel_purple.png"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeCity(
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _c(
                                                "h3",
                                                {
                                                  staticStyle: {
                                                    "text-align": "center"
                                                  }
                                                },
                                                [_vm._v("No City Selected")]
                                              )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.pickl.launchArea == "states"
                            ? _c(
                                "div",
                                {
                                  staticClass: "green-border-box mb10 checklist"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-6" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "checklist-head" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.selectAll,
                                                expression: "selectAll"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: "all-stores"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.selectAll
                                              )
                                                ? _vm._i(_vm.selectAll, null) >
                                                  -1
                                                : _vm.selectAll
                                            },
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$a = _vm.selectAll,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.selectAll = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.selectAll = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.selectAll = $$c
                                                  }
                                                },
                                                _vm.onSelectAllState
                                              ]
                                            }
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "all-stores" } },
                                            [_vm._v("Select States")]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "VuePerfectScrollbar",
                                        { staticClass: "checklist-contain" },
                                        [
                                          _c(
                                            "ul",
                                            { staticClass: "checklist-body" },
                                            _vm._l(_vm.states, function(state) {
                                              return _c(
                                                "li",
                                                {
                                                  key: state.id,
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setStateSelected(
                                                        state,
                                                        !state.selected
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "checklist-item"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            title: state.name
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(state.name)
                                                          )
                                                        ]
                                                      ),
                                                      _vm.inSelectedStatesList(
                                                        state
                                                      )
                                                        ? _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/img/Create Pickl/storenameSelect_icon.png"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-6" },
                                    [
                                      _vm._m(4),
                                      _c(
                                        "VuePerfectScrollbar",
                                        { staticClass: "checklist-contain" },
                                        [
                                          _vm.selectedStates.length > 0
                                            ? _c(
                                                "ul",
                                                {
                                                  staticClass: "checklist-body"
                                                },
                                                _vm._l(
                                                  _vm.selectedStates,
                                                  function(ss, index) {
                                                    return _c(
                                                      "li",
                                                      { key: ss.id },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "checklist-item"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                attrs: {
                                                                  title: ss.name
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    ss.name
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c("img", {
                                                              staticClass:
                                                                "remove-icon",
                                                              staticStyle: {
                                                                width: "24px",
                                                                height: "24px"
                                                              },
                                                              attrs: {
                                                                src:
                                                                  "/img/Create Pickl/cancel_purple.png"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeState(
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _c(
                                                "h3",
                                                {
                                                  staticStyle: {
                                                    "text-align": "center"
                                                  }
                                                },
                                                [_vm._v("No States Selected")]
                                              )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm.pickl.launchType == "global-any-location"
                      ? _c("div", [
                          _c("div", { staticClass: "filter-row" }, [
                            _c("div", { staticClass: "filter-control" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.countryId,
                                      expression: "pickl.countryId"
                                    }
                                  ],
                                  staticClass: "btn-select-box",
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.pickl,
                                          "countryId",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.getStates
                                    ]
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("Select Country")
                                  ]),
                                  _vm._l(_vm.countries, function(country) {
                                    return _c(
                                      "option",
                                      {
                                        key: country.id,
                                        domProps: { value: country.id }
                                      },
                                      [_vm._v(_vm._s(country.name))]
                                    )
                                  })
                                ],
                                2
                              )
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.pickl.location,
                                    expression: "pickl.location"
                                  }
                                ],
                                staticClass: "btn-select font-14px",
                                attrs: {
                                  type: "text",
                                  placeholder:
                                    "Enter Location (park, street, road etc.)"
                                },
                                domProps: { value: _vm.pickl.location },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.pickl,
                                      "location",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.maxTasksPerUser,
                                      expression: "pickl.maxTasksPerUser"
                                    }
                                  ],
                                  staticClass: "btn-select-box",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.pickl,
                                        "maxTasksPerUser",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      "Select Single User Completion Limit"
                                    )
                                  ]),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("1")
                                  ]),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v("2")
                                  ]),
                                  _c("option", { attrs: { value: "3" } }, [
                                    _vm._v("3")
                                  ]),
                                  _c("option", { attrs: { value: "4" } }, [
                                    _vm._v("4")
                                  ]),
                                  _c("option", { attrs: { value: "5" } }, [
                                    _vm._v("5")
                                  ])
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "filter-control" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pickl.responseCounter,
                                      expression: "pickl.responseCounter"
                                    }
                                  ],
                                  staticClass: "btn-select-box",
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.pickl,
                                        "responseCounter",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("Select quantity")
                                  ]),
                                  _vm._l(_vm.counterDropDownList, function(
                                    number
                                  ) {
                                    return _c(
                                      "option",
                                      {
                                        key: number,
                                        domProps: { value: number }
                                      },
                                      [_vm._v(_vm._s(number))]
                                    )
                                  })
                                ],
                                2
                              )
                            ])
                          ]),
                          _vm.states.length > 0 || _vm.selectedStates.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "green-border-box mb10 checklist"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-6" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "checklist-head" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.selectAll,
                                                expression: "selectAll"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: "all-stores"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.selectAll
                                              )
                                                ? _vm._i(_vm.selectAll, null) >
                                                  -1
                                                : _vm.selectAll
                                            },
                                            on: {
                                              change: [
                                                function($event) {
                                                  var $$a = _vm.selectAll,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.selectAll = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.selectAll = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.selectAll = $$c
                                                  }
                                                },
                                                _vm.onSelectAllState
                                              ]
                                            }
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "all-stores" } },
                                            [_vm._v("Select States")]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "VuePerfectScrollbar",
                                        { staticClass: "checklist-contain" },
                                        [
                                          _c(
                                            "ul",
                                            { staticClass: "checklist-body" },
                                            _vm._l(_vm.states, function(state) {
                                              return _c(
                                                "li",
                                                {
                                                  key: state.id,
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setStateSelected(
                                                        state,
                                                        !state.selected
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "checklist-item"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            title: state.name
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(state.name)
                                                          )
                                                        ]
                                                      ),
                                                      _vm.inSelectedStatesList(
                                                        state
                                                      )
                                                        ? _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/img/Create Pickl/storenameSelect_icon.png"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-6" },
                                    [
                                      _vm._m(5),
                                      _c(
                                        "VuePerfectScrollbar",
                                        { staticClass: "checklist-contain" },
                                        [
                                          _vm.selectedStates.length > 0
                                            ? _c(
                                                "ul",
                                                {
                                                  staticClass: "checklist-body"
                                                },
                                                _vm._l(
                                                  _vm.selectedStates,
                                                  function(ss, index) {
                                                    return _c(
                                                      "li",
                                                      { key: ss.id },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "checklist-item"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                attrs: {
                                                                  title: ss.name
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    ss.name
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c("img", {
                                                              staticClass:
                                                                "remove-icon",
                                                              staticStyle: {
                                                                width: "24px",
                                                                height: "24px"
                                                              },
                                                              attrs: {
                                                                src:
                                                                  "/img/Create Pickl/cancel_purple.png"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeRetailer(
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _c(
                                                "h3",
                                                {
                                                  staticStyle: {
                                                    "text-align": "center"
                                                  }
                                                },
                                                [_vm._v("No States Selected")]
                                              )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn-lg-grey",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.step = 3
                              }
                            }
                          },
                          [_vm._v("PREVIOUS")]
                        )
                      ]),
                      _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn-lg-green",
                            attrs: {
                              type: "button",
                              disabled: _vm.checkGoPicklValidation
                            },
                            on: { click: _vm.ValidateAndCreatPickl }
                          },
                          [_vm._v("GOOOOOO PICKL!")]
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        !_vm.OnBoarded & !_vm.LoadingBrand
          ? _c("div", { staticClass: "modal-body" }, [
              _c("h3", { staticClass: "text-center" }, [
                _vm._v(
                  "You made it! We will contact you soon to activate your credits."
                )
              ]),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c("router-link", {
                    attrs: {
                      "data-dismiss": "modal",
                      to: "/brand/subscription"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.LoadingBrand
          ? _c("div", [
              _c("h3", { staticClass: "text-center" }, [
                _vm._v("Please hold we're gathering your awesome data.")
              ])
            ])
          : _vm._e(),
        !_vm.geoPicklFeature && !_vm.LoadingBrand
          ? _c("div", [
              _c("h3", { staticClass: "text-center" }, [
                _vm._v(
                  "This feature is not available for you. Contact support!"
                )
              ])
            ])
          : _vm._e(),
        !(_vm.$store.state.brandCreditsRemaining > 0) &&
        !_vm.loadingCredits &&
        _vm.OnBoarded
          ? _c("div", { staticClass: "modal-body" }, [
              _c("h3", { staticClass: "text-center" }, [
                _vm._v("You don't have any pickls left!")
              ]),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        "data-dismiss": "modal",
                        to: "/brand/subscription"
                      }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn-lg-green wauto",
                          attrs: { type: "button" }
                        },
                        [_vm._v("GET MORE PICKLS")]
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c(
        "h2",
        { staticStyle: { "text-align": "center", "margin-top": "5px" } },
        [
          _vm._v("Welcome to "),
          _c("span", { staticClass: "green-text" }, [_vm._v("PICKL!  ")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
      _c("input", {
        staticClass: "btn-lg-green",
        attrs: { type: "submit", value: "NEXT" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-3" }, [
      _c("h2", { staticClass: "sub-heading pull-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checklist-head" }, [
      _c(
        "label",
        { staticStyle: { display: "block" }, attrs: { for: "all-stores" } },
        [_vm._v("States Ready To Blast")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checklist-head" }, [
      _c(
        "label",
        { staticStyle: { display: "block" }, attrs: { for: "all-stores" } },
        [_vm._v("States Ready To Blast")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checklist-head" }, [
      _c(
        "label",
        { staticStyle: { display: "block" }, attrs: { for: "all-stores" } },
        [_vm._v("States Ready To Blast")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }